import { defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import SimpleForm from "./SimpleForm"

interface Props {
	confirmText: string
	cancelText: string
	onCancel(): void
	onSubmit(): void
}

const ConfirmForm: ReactiveComponent<Props> = (props, { slots }) => {
	return () => (
		<SimpleForm onSubmit={props.onSubmit}>
			{renderSlot(slots)}
			<hr />
			<div class="flex justify-end">
				<div class="flex flex-wrap items-center spacing-3">
					<BootstrapButton color="secondary" type="button" onClick={props.onCancel}>
						{props.cancelText}
					</BootstrapButton>
					<BootstrapButton color="primary" type="submit">
						{props.confirmText}
					</BootstrapButton>
				</div>
			</div>
		</SimpleForm>
	)
}

export default defineComponent(ConfirmForm, inferProps<Props>())
